import React from 'react';
import {Link} from 'react-router-dom';
import './ProfileMenu.css'

const SettingsMenu = ({ active, current }) => {
  return (
    <div className="col col-12 col-md-4">
      <ul className="profile-menu">
        <li className="profile-menu-item">
          <Link to="/settings" className={(typeof active === 'undefined')?'active':''}>Settings</Link>
        </li>
        <li className="profile-menu-item">
          <Link to="/settings/payments" className={(active === 'payments')?'active':''}>Payments</Link>
        </li>
        <li className="profile-menu-item">
          <Link to="/settings/magnets" className={(active === 'magnets')?'active':''}>Magnets</Link>
        </li>
        {current.accountType === 'sugar_parent' &&<li className="profile-menu-item">
          <Link to="/settings/superior-passes" className={(active === 'superior-passes')?'active':''}>Superior Passes</Link>
        </li>}
        {current.accountType === 'sugar_baby' &&<li className="profile-menu-item">
          <Link to="/settings/promo-code" className={(active === 'promo-code')?'active':''}>PROMOCODE</Link>
        </li>}
      </ul>
      <button className="profile-link">
        <Link to={`/member/${current.name}`}>View my profile</Link>
      </button>
    </div>
  )
};

export default SettingsMenu;


// WEBPACK FOOTER //
// ./src/components/SettingsMenu.js